import React, { forwardRef } from "react";

import { ErrorMessage } from "./error-message";
import { Label, type LabelProps } from "./label";
import { TextArea, type TextAreaProps } from "./textarea";

type LabelledTextAreaProps = Omit<TextAreaProps, "id" | "style" | "error"> & {
  id: string;
  label: React.ReactChild;
  labelProps?: Pick<LabelProps, "id" | "tooltip" | "semibold">;
  error?: React.ReactChild;
};

export const LabelledTextArea = forwardRef<HTMLTextAreaElement, LabelledTextAreaProps>(
  function LabelledTextArea({ label, labelProps, error, ...props }, forwardedRef) {
    return (
      <div className="form-group">
        <Label {...labelProps} htmlFor={props.id} required={props.required}>
          {label}
        </Label>

        <TextArea
          {...props}
          ref={forwardedRef}
          error={Boolean(error)}
          aria-errormessage={error ? `${props.id}-error` : undefined}
        />

        {error ? <ErrorMessage id={props.id}>{error}</ErrorMessage> : null}
      </div>
    );
  },
);
